// firebase.js - CORRECCIÓN FINAL

import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAuc_NC5haio7F3RClmqTmtnmwbqMmWHdQ",
  authDomain: "hoprinplus-chat.firebaseapp.com",
  projectId: "hoprinplus-chat",
  storageBucket: "hoprinplus-chat.appspot.com",
  messagingSenderId: "459600736523",
  appId: "1:459600736523:web:a3299d4780227d5f3a320e"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app, 'us-central1');

export { db, auth, functions };